module.exports = __webpack_public_path__ + "img/supplement.740bcf7.svg";